import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const ChatIcon = (props: { style?: StyleProp<ViewStyle> }) => {
	const user = useAppSelector((s) => s.auth.subUser!);
	
  return (
    <Svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill={getPrimaryColor(user)}
      {...props}
    >
      <Path
        d="M19.9683 0.8H19.9681L9.03174 0.8L9.03151 0.8C6.84911 0.802494 4.75682 1.67056 3.21365 3.21377C1.67048 4.75697 0.80245 6.84928 0.8 9.03168V9.0319L0.8 13.4482L0.8 13.4485C0.802447 15.4688 1.54671 17.4178 2.89146 18.9255C4.17517 20.3648 5.92075 21.3062 7.82237 21.5909L5.29542 27.0647L5.29541 27.0647C5.222 27.2237 5.20282 27.4025 5.24083 27.5735C5.27883 27.7445 5.37191 27.8983 5.50577 28.0113C5.63964 28.1243 5.80689 28.1902 5.98185 28.199C6.15682 28.2078 6.32981 28.1588 6.47429 28.0598L6.4743 28.0598L15.7763 21.6801H19.9681H19.9683C22.1508 21.6777 24.2431 20.8096 25.7863 19.2664C27.3295 17.7232 28.1975 15.6309 28.2 13.4485V13.4482V9.0319V9.03168C28.1975 6.84926 27.3295 4.75693 25.7863 3.21372C24.2431 1.67052 22.1508 0.802463 19.9683 0.8ZM15.0758 20.2204L7.9665 25.0962L9.7581 21.2155L9.75812 21.2154C9.81435 21.0935 9.83902 20.9594 9.82983 20.8255C9.82065 20.6916 9.77792 20.5621 9.70558 20.449C9.63323 20.336 9.5336 20.2429 9.41585 20.1784C9.29816 20.114 9.16615 20.0802 9.03197 20.0801C7.27365 20.0781 5.58793 19.3787 4.34463 18.1354C3.10133 16.8921 2.40197 15.2063 2.4 13.448V9.03212C2.40197 7.27381 3.10132 5.58807 4.34462 4.34473C5.58793 3.1014 7.27365 2.40201 9.03197 2.4H19.9679C21.7262 2.40198 23.412 3.10136 24.6553 4.34469C25.8987 5.58803 26.598 7.27379 26.6 9.03213V13.448C26.598 15.2064 25.8986 16.8921 24.6553 18.1354C23.412 19.3788 21.7262 20.0781 19.9679 20.0801H15.5284C15.5283 20.0801 15.5283 20.0801 15.5283 20.0801C15.3668 20.0801 15.209 20.129 15.0758 20.2204Z"
        strokeWidth="0.4"
      />
    </Svg>
  );
};
export default ChatIcon;
